import { Box, Grid, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OutlinedButton from "../OutlinedButton";
import logo from "../../assets/logo.png";
import styles, { fadeIn, fadeInUp } from "./styles";

const MainBanner = ({ imageRef }) => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.bannerWrapperSx}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={styles.logoAnimatedGridSx(fadeIn)}
      >
        <Grid item xs={12} display="flex" justifyContent="center">
          <Box
            ref={imageRef}
            component="img"
            src={logo}
            alt="Logo"
            sx={styles.logoImageSx}
          />
        </Grid>
        <Grid item xs={12} sx={styles.dividerSx} />
      </Grid>

      {/* Rest of content rises as one block */}
      <Box sx={styles.contentBlockSx(fadeInUp)}>
        <Typography variant="overline" sx={styles.locationSx}>
          Tbilisi · Georgia
        </Typography>

        <Typography variant="h1" align="center" sx={styles.headlineSx}>
          Booking Waves
        </Typography>

        <Typography variant="body1" align="center" sx={styles.subheadlineSx}>
          Independent music platform, collective and cultural community space
        </Typography>

        <Box sx={styles.decoratorRowSx}>
          <Box sx={styles.decoratorLineSx} />
          <Box sx={styles.decoratorDotSx} />
          <Box sx={styles.decoratorLineSx} />
        </Box>

        <OutlinedButton sx={styles.bookButtonSx} onClick={() => navigate("/events")}>
          View Events
        </OutlinedButton>
      </Box>

      {/* Scroll indicator — mobile only */}
      <Box sx={styles.scrollIndicatorSx}>
        <Box sx={styles.scrollLineSx} />
      </Box>
    </Box>
  );
};

export default MainBanner;
